import React, { useState } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';

// ==================== SVG ICONS ====================


const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

const ChartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 20V10M12 20V4M6 20v-6"/>
  </svg>
);

const RefreshIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  </svg>
);

// ==================== STYLES ====================

const styles = `
  .uac-panel {
    padding: 0;
  }

  .uac-loading {
    padding: 2rem;
    text-align: center;
    color: #64748b;
    font-size: 0.8rem;
  }

  .uac-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid #e2e8f0;
    border-top-color: #2563eb;
    border-radius: 50%;
    animation: uac-spin 1s linear infinite;
    margin: 0 auto 10px;
  }

  @keyframes uac-spin {
    to { transform: rotate(360deg); }
  }

  .uac-error {
    padding: 1rem;
    background: #fef2f2;
    border-left: 4px solid #ef4444;
    border-radius: 6px;
    color: #991b1b;
    font-size: 0.8rem;
  }

  .uac-error button {
    margin-top: 8px;
    padding: 4px 10px;
    background: #2563eb;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 0.75rem;
    cursor: pointer;
  }

  /* Notification */
  .uac-notif {
    position: fixed;
    top: 70px;
    right: 16px;
    padding: 10px 14px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 1000;
    animation: uac-slideIn 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    font-size: 0.75rem;
  }

  .uac-notif.success {
    background: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
  }

  .uac-notif.error {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
  }

  .uac-notif button {
    background: none;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    opacity: 0.7;
    padding: 0;
    line-height: 1;
  }

  .uac-notif button:hover {
    opacity: 1;
  }

  @keyframes uac-slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  /* Info Box */
  .uac-info {
    background: #fffbeb;
    padding: 10px 14px;
    border-radius: 6px;
    margin-bottom: 16px;
    border-left: 4px solid #f59e0b;
  }

  .uac-info p {
    margin: 0;
    color: #92400e;
    font-size: 0.75rem;
    line-height: 1.5;
  }

  /* Table Card */
  .uac-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-left: 4px solid #2563eb;
    border-radius: 6px;
    overflow: hidden;
  }

  .uac-table-container {
    overflow-x: auto;
  }

  .uac-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.75rem;
  }

  .uac-table th {
    background: #f1f5f9;
    color: #64748b;
    font-weight: 600;
    font-size: 0.65rem;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
  }

  .uac-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #e2e8f0;
    color: #334155;
  }

  .uac-table tbody tr:hover {
    background: #f8fafc;
  }

  .uac-table tbody tr.inactive {
    opacity: 0.6;
  }

  .uac-table tbody tr:last-child td {
    border-bottom: none;
  }

  /* User Cell */
  .uac-user-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .uac-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2563eb, #1e40af);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.7rem;
    flex-shrink: 0;
  }

  .uac-user-details {
    display: flex;
    flex-direction: column;
  }

  .uac-user-name {
    font-weight: 600;
    color: #1e3a8a;
    font-size: 0.8rem;
  }

  .uac-user-email {
    font-size: 0.65rem;
    color: #94a3b8;
  }

  /* Badges */
  .uac-role-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.65rem;
    font-weight: 600;
  }

  .uac-role-badge.super_admin {
    background: #dbeafe;
    color: #1e40af;
  }

  .uac-role-badge.admin {
    background: #dbeafe;
    color: #1e40af;
  }

  .uac-role-badge.manager {
    background: #e0f2fe;
    color: #0369a1;
  }

  .uac-role-badge.operator {
    background: #f1f5f9;
    color: #475569;
  }

  .uac-role-badge.viewer {
    background: #f1f5f9;
    color: #64748b;
  }

  .uac-status-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 0.6rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .uac-status-badge.active {
    background: #dcfce7;
    color: #166534;
  }

  .uac-status-badge.inactive {
    background: #f1f5f9;
    color: #64748b;
  }

  .uac-status-badge.pending_activation {
    background: #fef3c7;
    color: #92400e;
  }

  .uac-status-badge.suspended {
    background: #fef2f2;
    color: #991b1b;
  }

  /* Toggle Switch */
  .uac-toggle {
    position: relative;
    display: inline-block;
    width: 36px;
    height: 20px;
  }

  .uac-toggle input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .uac-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    transition: 0.3s;
    border-radius: 20px;
  }

  .uac-slider:before {
    position: absolute;
    content: "";
    height: 14px;
    width: 14px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .uac-toggle input:checked + .uac-slider {
    background-color: #f59e0b;
  }

  .uac-toggle input:checked + .uac-slider:before {
    transform: translateX(16px);
  }

  .uac-toggle input:disabled + .uac-slider {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Summary */
  .uac-summary {
    margin-top: 16px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-left: 4px solid #2563eb;
    border-radius: 6px;
    padding: 12px 14px;
  }

  .uac-summary-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
  }

  .uac-summary-header h3 {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 600;
    color: #1e40af;
  }

  .uac-summary-header svg {
    color: #3b82f6;
  }

  .uac-summary-grid {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .uac-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 16px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    min-width: 80px;
  }

  .uac-stat-value {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e40af;
  }

  .uac-stat-label {
    font-size: 0.65rem;
    color: #64748b;
    margin-top: 2px;
    text-align: center;
  }

  @media (max-width: 768px) {
    .uac-table-container {
      overflow-x: auto;
    }

    .uac-table {
      min-width: 550px;
    }

    .uac-summary-grid {
      justify-content: center;
    }
  }
`;

const GET_USERS_FOR_ACCESS_CONTROL = gql`
  query GetUsersForAccessControl {
    getUsersForAccessControl {
      id
      username
      email
      firstName
      lastName
      role
      status
      accesoConfiguracion
      lastLoginAt
      createdAt
    }
  }
`;

const UPDATE_USER_CONFIG_ACCESS = gql`
  mutation UpdateUserConfigAccess($userId: ID!, $accesoConfiguracion: Boolean!) {
    updateUserConfigAccess(userId: $userId, accesoConfiguracion: $accesoConfiguracion) {
      id
      username
      accesoConfiguracion
    }
  }
`;

interface User {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  accesoConfiguracion: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

const roleLabels: Record<string, string> = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Administrador',
  MANAGER: 'Gerente',
  OPERATOR: 'Operador',
  VIEWER: 'Visor',
};

const statusLabels: Record<string, string> = {
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
  PENDING_ACTIVATION: 'Pendiente',
  SUSPENDED: 'Suspendido',
};

export const UserAccessControl: React.FC = () => {
  const { data, loading, error, refetch } = useQuery(GET_USERS_FOR_ACCESS_CONTROL);
  const [updateAccess, { loading: updating }] = useMutation(UPDATE_USER_CONFIG_ACCESS);

  const [notification, setNotification] = useState<{
    type: 'success' | 'error';
    message: string;
  } | null>(null);

  const handleToggleAccess = async (user: User) => {
    try {
      await updateAccess({
        variables: {
          userId: user.id,
          accesoConfiguracion: !user.accesoConfiguracion,
        },
      });

      setNotification({
        type: 'success',
        message: `Acceso ${!user.accesoConfiguracion ? 'habilitado' : 'deshabilitado'} para ${user.firstName} ${user.lastName}`,
      });

      refetch();
    } catch (err: any) {
      setNotification({
        type: 'error',
        message: err.message || 'Error al actualizar el acceso',
      });
    }

    setTimeout(() => setNotification(null), 3000);
  };

  if (loading) {
    return (
      <div className="uac-panel">
        <style>{styles}</style>
        <div className="uac-loading">
          <div className="uac-spinner"></div>
          <p>Cargando usuarios...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="uac-panel">
        <style>{styles}</style>
        <div className="uac-error">
          <p>Error al cargar usuarios: {error.message}</p>
          <button onClick={() => refetch()}>
            <RefreshIcon /> Reintentar
          </button>
        </div>
      </div>
    );
  }

  const users: User[] = data?.getUsersForAccessControl || [];

  return (
    <div className="uac-panel">
      <style>{styles}</style>

      {/* Notification */}
      {notification && (
        <div className={`uac-notif ${notification.type}`}>
          {notification.type === 'success' ? <CheckIcon /> : <XIcon />}
          {notification.message}
          <button onClick={() => setNotification(null)}>×</button>
        </div>
      )}

      {/* Info Box */}
      <div className="uac-info">
        <p>
          Gestiona qué usuarios requieren validación de contraseña para acceder al módulo de Configuración.
          Los usuarios con "Requiere Validación" activo deberán ingresar su contraseña cada vez que accedan.
        </p>
      </div>

      {/* Users Table */}
      <div className="uac-card">
        <div className="uac-table-container">
          <table className="uac-table">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Rol</th>
                <th>Estado</th>
                <th>Último Acceso</th>
                <th>Requiere Validación</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className={user.status !== 'ACTIVE' ? 'inactive' : ''}>
                  <td>
                    <div className="uac-user-cell">
                      <div className="uac-avatar">
                        {user.firstName.charAt(0)}{user.lastName.charAt(0)}
                      </div>
                      <div className="uac-user-details">
                        <span className="uac-user-name">{user.firstName} {user.lastName}</span>
                        <span className="uac-user-email">{user.email}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className={`uac-role-badge ${user.role.toLowerCase()}`}>
                      {roleLabels[user.role] || user.role}
                    </span>
                  </td>
                  <td>
                    <span className={`uac-status-badge ${user.status.toLowerCase()}`}>
                      {statusLabels[user.status] || user.status}
                    </span>
                  </td>
                  <td>
                    {user.lastLoginAt
                      ? new Date(user.lastLoginAt).toLocaleString('es-CO', {
                          dateStyle: 'short',
                          timeStyle: 'short',
                        })
                      : 'Nunca'}
                  </td>
                  <td>
                    <label className="uac-toggle">
                      <input
                        type="checkbox"
                        checked={user.accesoConfiguracion}
                        onChange={() => handleToggleAccess(user)}
                        disabled={updating || user.status !== 'ACTIVE'}
                      />
                      <span className="uac-slider"></span>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Summary */}
      <div className="uac-summary">
        <div className="uac-summary-header">
          <ChartIcon />
          <h3>Resumen</h3>
        </div>
        <div className="uac-summary-grid">
          <div className="uac-stat">
            <span className="uac-stat-value">{users.length}</span>
            <span className="uac-stat-label">Total</span>
          </div>
          <div className="uac-stat">
            <span className="uac-stat-value">{users.filter(u => u.accesoConfiguracion).length}</span>
            <span className="uac-stat-label">Requieren Validación</span>
          </div>
          <div className="uac-stat">
            <span className="uac-stat-value">{users.filter(u => u.status === 'ACTIVE').length}</span>
            <span className="uac-stat-label">Activos</span>
          </div>
        </div>
      </div>
    </div>
  );
};
